// extracted by css-extract-rspack-plugin
export default {"root":"root-A2y8SW"};